import get from 'lodash/get';
import { reduxKey } from './constants';
import { initialState } from './reducer';
import { getCurrentStreamId } from '../../Duperbrowse/redux/selectors';
import { FEEDBACK_PAGE_DUPERBROWSE_STREAMID } from '../../Duperbrowse/redux/constants';
export function getSiteHeaderState(state) {
    return get(state, reduxKey, initialState);
}
export function getIsNotificationsDropdownOpen(state) {
    return getSiteHeaderState(state).isNotificationsDropdownOpen;
}
export function getIsSearchModalShown(state) {
    return getSiteHeaderState(state).isSearchModalShown;
}
export function getIsUserDropdownOpen(state) {
    return getSiteHeaderState(state).isUserDropdownOpen;
}
export function getIsBurgerMenuOpen(state) {
    return getSiteHeaderState(state).isBurgerMenuOpen;
}
export function getIsFeedbackPageOpen(state) {
    return getCurrentStreamId(state) === FEEDBACK_PAGE_DUPERBROWSE_STREAMID;
}

//# sourceMappingURL=selectors.js.map